import { Text } from '@shared/components/Text';
import { ButtonView, View } from '@shared/components/View';
import { CalendarDate, RangeSelection } from '@shared/components/dateAndTime/calendar';
import styles from './CalendarDay.module.css';

interface Props {
  day: CalendarDate;
  disabled: boolean;
  onClick(): void;
}

export function CalendarDay({ day, disabled, onClick }: Props) {
  if (!day) {
    return <View className={styles.cell} />;
  }

  const { label, selected, weekend, today, range, highlighted, currentMonth } = day;
  const isRangeStart = range === RangeSelection.start || range === RangeSelection.single;
  const isRangeEnd = range === RangeSelection.end || range === RangeSelection.single;
  const isRangeBoundary = isRangeStart || isRangeEnd;
  const isSelected = selected || isRangeBoundary;
  return (
    <ButtonView disabled={disabled} className={styles.cell} onClick={onClick}>
      {range === RangeSelection.start && <View className={[styles.rangeFill, styles.start]} />}
      {range === RangeSelection.middle && <View className={[styles.rangeFill, styles.middle]} />}
      {range === RangeSelection.end && <View className={[styles.rangeFill, styles.end]} />}
      <View
        className={[
          styles.dayCircle,
          highlighted && styles.highlighted,
          isSelected && styles.selected,
          today && isSelected && styles.selectedToday,
        ]}
        testID={today ? 'calendar-picker-today' : undefined}
      >
        <Text
          size="subtitle"
          className={[
            styles.dayText,
            weekend && styles.weekend,
            !currentMonth && styles.outsideMonth,
            today && styles.today,
            disabled && styles.disabled,
            highlighted && styles.highlighted,
            isSelected && styles.selected,
          ]}
        >
          {label}
        </Text>
      </View>
    </ButtonView>
  );
}
